import keywordFilterBlock from "./keywordFilterBlock";
import queryModelTransformer from "../../conversionEngine/queryModelTransformer";
import { getTagElements, getTables, getMappings } from "../../apiFactory/QueryBuilder";
import conversionEngine from "../../conversionEngine/engine";

/**
 * Returns the dropdown value for fields
 * @param {*} fieldConfig
 * @param {*} keywords
 */
const computeDropdownValues = (
	organizationId,
	fieldConfig,
	keywords,
	tableHash,
	fieldSet,
	baseTable,
	stagesModel
) => {
	let result = [];
	const filteredKeywords = keywordFilterBlock(fieldConfig, keywords);
	if (fieldConfig["custom-input-data"]) {
		result = fieldConfig["custom-dropdown-data"];
		return Promise.resolve(result);
	} else if (fieldConfig["input-data"] === "keywords") {
		result = filteredKeywords.map(keyword => {
			return {
				label: keyword.keyword,
				value: keyword.keyword,
				dataType: keyword.dataType
			};
		});
		return Promise.resolve(result);
	} else if (fieldConfig["input-data"] === "tables") {
		const tables = [];
		for (let tableName in tableHash) {
			tables.push(tableHash[tableName]);
		}
		result = tables.map(table => ({
			label: table.tableAlias,
			value: table.tableName
		}));
		return Promise.resolve(result);
	} else if (fieldConfig["input-data"] === "foreign-keywords") {
		const dependentKey = fieldConfig["dependent-key"];
		const dependentFieldValue = fieldSet.find(field => field["field-name"] === dependentKey).value;
		if (dependentFieldValue) {
			result = tableHash[dependentFieldValue].keywords.map(keyword => {
				return {
					label: keyword.keyword,
					value: keyword.keyword,
					dataType: keyword.dataType
				};
			});
		} else {
			result = [];
		}
		return Promise.resolve(result);
	} else if (fieldConfig["input-data"] === "tag-values") {
		return Promise.resolve({
			then: (resolve, reject) => {
				let filter = [];
				let foreignTable, foreignField;
				const dependentFieldValue = fieldSet.find(field => field["field-name"] === "keyword").value;
				for (let i = 0; i < keywords.length; i++) {
					if (dependentFieldValue === keywords[i].keyword) {
						foreignTable = keywords[i].foreignTable;
						foreignField = keywords[i].foreignField;
						if (keywords[i].filter) {
							filter.push(keywords[i].filter);
						}
						break;
					}
				}
				getTagElements(organizationId, foreignTable, filter)
					.then(data => {
						let options = data.data.map(option => {
							return {
								label: option.name,
								value: option[foreignField]
							};
						});
						resolve(options);
					})
					.catch(err => {
						console.log("something went wrong");
						return err;
					});
			}
		});
	} else if (fieldConfig["input-data"] === "project-values") {
		return Promise.resolve({
			then: (resolve, reject) => {
				const dependentFieldValue = fieldSet.find(field => field["field-name"] === "keyword").value;
				let thinkerQuery;
				if (stagesModel && stagesModel.length) {
					const uiQuery = queryModelTransformer({
						queryModel: { stagesModel },
						baseTable,
						organizationId
					});
					thinkerQuery = conversionEngine(
						{
							baseTable,
							organizationID: organizationId,
							query: uiQuery
						},
						"execute"
					);
					thinkerQuery.query.splice(-1, 1);
				}
				let filter;
				if (thinkerQuery) {
					filter = [
						...thinkerQuery.query,
						{
							group: {
								by: [`${dependentFieldValue}`]
							}
						},
						{
							join: {
								from: "project",
								localColumn: `id.${dependentFieldValue}`,
								foreignColumn: "projectId",
								as: "project"
							}
						},
						{
							addfields: {
								projectId: `$id.${dependentFieldValue}`,
								projectName: "$project.name"
							}
						},
						{
							removefields: ["id", "project"]
						}
					];
				}
				if (filter) {
					getTagElements(organizationId, baseTable, filter)
						.then(data => {
							let options = data.data.map(option => {
								return {
									label: option.projectName,
									value: option.projectId
								};
							});
							resolve(options);
						})
						.catch(err => {
							console.log("something went wrong");
							return err;
						});
				} else {
					resolve([]);
				}
			}
		});
	} else if (fieldConfig["input-data"] === "table-columns") {
		const dependentKey = fieldConfig["dependent-key"];
		const dependentFieldValue = fieldSet.find(field => field["field-name"] === dependentKey).value;
		if (dependentFieldValue) {
			let tableKeyword = keywords.find(keyword => {
				return keyword.keyword === dependentFieldValue;
			});
			if (tableKeyword) {
				let options = tableKeyword.tableColumns.map(element => {
					return {
						label: element.displayName,
						value: element.keyword
					};
				});
				result = options;
			} else {
				result = [];
			}
		} else {
			result = [];
		}
		return Promise.resolve(result);
	} else if (fieldConfig["input-data"] === "profile-ref-values") {
		return Promise.resolve({
			then: (resolve, reject) => {
				const dependentFieldValue = fieldSet.find(field => field["field-name"] === "keyword").value;
				let keyword = keywords.find(elem => {
					return elem.keyword === dependentFieldValue;
				});
				let thinkerQuery;
				if (stagesModel && stagesModel.length) {
					const uiQuery = queryModelTransformer({
						queryModel: { stagesModel },
						baseTable,
						organizationId
					});
					thinkerQuery = conversionEngine(
						{
							baseTable,
							organizationID: organizationId,
							query: uiQuery
						},
						"execute"
					);
					thinkerQuery.query.splice(-1, 1);
				}
				let filter;
				if (thinkerQuery) {
					filter = [
						...thinkerQuery.query,
						{
							group: {
								by: [`${dependentFieldValue}`]
							}
						},
						{
							join: {
								from: `${keyword.foreignTable}`,
								localColumn: `id.${dependentFieldValue}`,
								foreignColumn: "id",
								as: "profile_ref"
							}
						},
						{
							addfields: {
								profileRefId: `$id.${dependentFieldValue}`,
								profileRefName: "$profile_ref.name"
							}
						},
						{
							removefields: ["id", "profile_ref"]
						}
					];
				}
				if (filter) {
					getTagElements(organizationId, baseTable, filter)
						.then(data => {
							let options = data.data.map(option => {
								return {
									label: option.profileRefName,
									value: option.profileRefId
								};
							});
							resolve(options);
						})
						.catch(err => {
							console.log("something went wrong");
							return err;
						});
				} else {
					resolve([]);
				}
			}
		});
	} else {
		return [];
	}
};

export default computeDropdownValues;
